import { render, staticRenderFns } from "./CoinList.vue?vue&type=template&id=180fbc98&scoped=true&"
import script from "./CoinList.vue?vue&type=script&lang=js&"
export * from "./CoinList.vue?vue&type=script&lang=js&"
import style0 from "./CoinList.vue?vue&type=style&index=0&id=180fbc98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180fbc98",
  null
  
)

export default component.exports